<template>
  <v-expansion-panels
    class="medication__expansion-panel"
    focusable
  >
    <v-expansion-panel>
      <v-expansion-panel-header
        :color="color"
        class="medication__expansion-panel-header ignoredisableall"
      >
        {{ $t('dss.changeHistory') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table class="change-history__table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $t('medication.what') }}</th>
                <th class="text-left">{{ $t('medication.when') }}</th>
                <th class="text-left">{{ $t('medication.who') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in auditTrails"
                :key="`${medicationId}-history-${index}`"
              >
                <td>{{ $t(item.what) }}</td>
                <td>{{ item.when | date }}</td>
                <td>{{ $t(filterOldRoles(item.who)) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component MedicationChangeHistory.vue
 *
 * @module MedicationChangeHistory
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationChangeHistory.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationChangeHistory',
  props: {
    medicationId: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      auditTrailsNodes: 'dss/auditTrailsNodes',
    }),
    auditTrails() {
      return this.auditTrailsNodes
        .filter((node) => node.medicationScheduleId === this.medicationId);
    },
  },
  methods: {
    filterOldRoles: (roleKey) => {
      // Fix old translationkey from DB
      return roleKey.replace('roles', 'people');
    }
  }
};
</script>

<style lang="scss">
.medication__expansion-panel {
  // max-width: 1036px;

  .v-data-table {
    background-color: transparent;
  }

  .v-expansion-panel {
    background: transparent !important;
  }

  .v-expansion-panel-header {
    padding-right: 12px;
    padding-left: 12px;
    line-height: 20px;
    background: transparent;
    font-family: "Poppins", sans-serif;
  }

  .v-expansion-panel {
    border-bottom: 0 !important;
  }

  .v-expansion-panel-content__wrap {
    padding-right: 0;
    padding-left: 0;
  }

  .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active:hover::before,
  .theme--light.v-expansion-panels.v-expansion-panels--focusable .v-expansion-panel-header--active::before {
    opacity: 0;
  }

  .change-history__table {
    font-family: Roboto, sans-serif;
    font-weight: 400;

    table > thead > tr > th,
    table > tbody > tr > td {
      font-size: 0.9rem !important;
      line-height: 1.6 !important;
    }
  }

  .medication__expansion-panel-header {
    font-size: 0.9rem;
  }
}
</style>
